<app-hardware-configuration-card
  [hardwareID]="existingHwId ? existingHwId : 'new'"
  (hardwareIDChange)="saveHwConfig($event)"
></app-hardware-configuration-card>

<app-exit-button (click)="dialogRef.close()"> </app-exit-button>
